module.exports = new __parcel__URL__("logo_lorient.c03b280b.png").toString();